import { CSSProperties } from 'react';

export const getFsPaperStyle = (isUpMd: boolean): CSSProperties => {
  return {
    borderTopRightRadius: isUpMd ? 0 : 10,
    borderBottomRightRadius: isUpMd ? 0 : 10,
    width: isUpMd ? '50%' : '100%',
  };
};

export default {
  getFsPaperStyle,
};
